import MainDialogMobile from './main_dialog_mobile';
import MainDialogTv from './main_dialog_tv';

export { MainDialogMobile, MainDialogTv };
